export default [
    {
        "name": "巡检表",
        "freeze": "A1",
        "styles": [
            {
                "align": "center"
            },
            {
                "align": "center",
                "textwrap": true
            },
            {
                "textwrap": true
            },
            {
                "align": "center",
                "textwrap": false
            },
            {
                "textwrap": false
            }
        ],
        "merges": [
            "B1:G1",
            "H1:Q1",
            "B2:B3",
            "C2:C3",
            "D2:F2",
            "H2:I2",
            "J2:K2",
            "L2:M2",
            "N2:O2",
            "P2:Q2",
            "R2:R3",
            "S2:S3",
            "T2:T3",
            "U2:U3",
            "V2:V3",
            "W2:W3",
            "X2:X3",
            "Y2:Y3",
            "Z2:Z3",
            "AA2:AA3",
            "AB2:AB3",
            "AC2:AC3",
            "AD2:AD3",
            "AE2:AE3",
            "AF2:AF3",
            "AG2:AG3",
            "AH2:AH3",
            "AI2:AI3",
            "AJ2:AJ3",
            "AK2:AK3",
            "AL2:AL3",
            "AK1:AL1",
            "A1:A3",
            "G2:G3",
            "R1:AC1",
            "AD1:AJ1",
            "AN2:AN3",
            "AM2:AM3"
        ],
        "rows": {
            "0": {
                "cells": {
                    "0": {
                        "text": "日期",
                        "merge": [
                            2,
                            0
                        ],
                        "style": 3
                    },
                    "1": {
                        "text": "生产数据",
                        "merge": [
                            0,
                            5
                        ],
                        "style": 3
                    },
                    "2": {
                        "style": 3
                    },
                    "3": {
                        "style": 3
                    },
                    "4": {
                        "style": 3
                    },
                    "5": {
                        "style": 3
                    },
                    "6": {
                        "style": 3
                    },
                    "7": {
                        "text": "水质分析",
                        "merge": [
                            0,
                            9
                        ],
                        "style": 3
                    },
                    "8": {
                        "style": 3
                    },
                    "9": {
                        "style": 3
                    },
                    "10": {
                        "style": 3
                    },
                    "11": {
                        "style": 3
                    },
                    "12": {
                        "style": 3
                    },
                    "13": {
                        "style": 3
                    },
                    "14": {
                        "style": 3
                    },
                    "15": {
                        "style": 3
                    },
                    "16": {
                        "style": 3
                    },
                    "17": {
                        "style": 3,
                        "text": "设备巡检",
                        "merge": [
                            0,
                            11
                        ]
                    },
                    "29": {
                        "style": 3,
                        "text": "工艺巡检",
                        "merge": [
                            0,
                            6
                        ]
                    },
                    "36": {
                        "text": "维修",
                        "style": 3,
                        "merge": [
                            0,
                            1
                        ]
                    },
                    "37": {
                        "style": 4
                    },
                    "39": {
                        "style": 3
                    },
                    "40": {
                        "text": ""
                    },
                    "41": {
                        "text": ""
                    },
                    "42": {
                        "text": ""
                    },
                    "43": {
                        "text": "工艺巡检"
                    },
                    "44": {
                        "text": ""
                    },
                    "45": {
                        "text": ""
                    },
                    "46": {
                        "text": ""
                    },
                    "47": {
                        "text": ""
                    },
                    "48": {
                        "text": ""
                    },
                    "49": {
                        "text": ""
                    },
                    "50": {
                        "text": "维修"
                    },
                    "51": {
                        "text": ""
                    }
                },
                "height": 25
            },
            "1": {
                "cells": {
                    "1": {
                        "text": "处理水量",
                        "merge": [
                            1,
                            0
                        ],
                        "style": 1
                    },
                    "2": {
                        "text": "耗电量",
                        "merge": [
                            1,
                            0
                        ],
                        "style": 1
                    },
                    "3": {
                        "text": "药剂消耗量\nKG",
                        "style": 1,
                        "merge": [
                            0,
                            2
                        ]
                    },
                    "4": {
                        "style": 1
                    },
                    "5": {
                        "style": 1
                    },
                    "6": {
                        "text": "污泥产量",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "7": {
                        "text": "PH",
                        "style": 1,
                        "merge": [
                            0,
                            1
                        ]
                    },
                    "8": {
                        "style": 2
                    },
                    "9": {
                        "text": "CODcr",
                        "style": 1,
                        "merge": [
                            0,
                            1
                        ]
                    },
                    "10": {
                        "style": 2
                    },
                    "11": {
                        "text": "NH3-N",
                        "style": 1,
                        "merge": [
                            0,
                            1
                        ]
                    },
                    "12": {
                        "style": 2
                    },
                    "13": {
                        "text": "TN",
                        "style": 1,
                        "merge": [
                            0,
                            1
                        ]
                    },
                    "14": {
                        "style": 2
                    },
                    "15": {
                        "text": "TP",
                        "style": 1,
                        "merge": [
                            0,
                            1
                        ]
                    },
                    "16": {
                        "style": 2
                    },
                    "17": {
                        "text": "瞬时流量",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "18": {
                        "text": "水泵频率",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "19": {
                        "text": "风机频率",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "20": {
                        "text": "格栅清理",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "21": {
                        "text": "提升泵清理",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "22": {
                        "text": "设备各生化单元流水是否通畅",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "23": {
                        "text": "提升泵运行正常无异响",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "24": {
                        "text": "电磁阀工作正常且螺栓紧固无松动或脱落",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "25": {
                        "text": "风机（气泵）运行正常无异响是否清洁",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "26": {
                        "text": "风机滴油滴油≥10滴/每分钟",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "27": {
                        "text": "控制柜电气原件故障",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "28": {
                        "text": "场站杂草卫生打扫",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "29": {
                        "text": "预脱硝池、厌氧池、缺氧池搅拌阶段出气正常",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "30": {
                        "text": "设备曝气均匀、水花平稳翻滚、填料流化正常",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "31": {
                        "text": "各池体间过水孔过水通畅",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "32": {
                        "text": "设备实际水流量在设计范围内",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "33": {
                        "text": "好氧池污泥是否正常",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "34": {
                        "text": "SV30",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "35": {
                        "text": "设备产水清澈",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "36": {
                        "text": "故障",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "37": {
                        "text": "处理方法",
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ]
                    },
                    "38": {
                        "merge": [
                            1,
                            0
                        ],
                        "text": "巡检人",
                        "style": 0
                    },
                    "39": {
                        "style": 1,
                        "merge": [
                            1,
                            0
                        ],
                        "text": "项目"
                    },
                    "40": {
                        "text": "风机滴油滴油≥10滴/每分钟"
                    },
                    "41": {
                        "text": "控制柜电气原件故障"
                    },
                    "42": {
                        "text": "场站杂草卫生打扫"
                    },
                    "43": {
                        "text": "预脱硝池、厌氧池、缺氧池搅拌阶段出气正常"
                    },
                    "44": {
                        "text": "设备曝气均匀、水花平稳翻滚、填料流化正常"
                    },
                    "45": {
                        "text": "各池体间过水孔过水通畅"
                    },
                    "46": {
                        "text": "设备实际水流量在设计范围内"
                    },
                    "47": {
                        "text": "好氧池污泥是否正常"
                    },
                    "48": {
                        "text": "SV30"
                    },
                    "49": {
                        "text": "设备产水清澈"
                    },
                    "50": {
                        "text": "故障"
                    },
                    "51": {
                        "text": "处理方法"
                    }
                },
                "height": 41
            },
            "2": {
                "cells": {
                    "1": {
                        "style": 3
                    },
                    "2": {
                        "style": 3
                    },
                    "3": {
                        "text": "碳源",
                        "style": 3
                    },
                    "4": {
                        "text": "PAC",
                        "style": 3
                    },
                    "5": {
                        "text": "消毒剂",
                        "style": 3
                    },
                    "7": {
                        "text": "进水",
                        "style": 3
                    },
                    "8": {
                        "text": "出水",
                        "style": 3
                    },
                    "9": {
                        "text": "进水",
                        "style": 3
                    },
                    "10": {
                        "text": "出水",
                        "style": 3
                    },
                    "11": {
                        "text": "进水",
                        "style": 3
                    },
                    "12": {
                        "text": "出水",
                        "style": 3
                    },
                    "13": {
                        "text": "进水",
                        "style": 3
                    },
                    "14": {
                        "text": "出水",
                        "style": 3
                    },
                    "15": {
                        "text": "进水",
                        "style": 3
                    },
                    "16": {
                        "text": "出水",
                        "style": 3
                    },
                    "17": {
                        "style": 4
                    },
                    "18": {
                        "style": 4
                    },
                    "19": {
                        "style": 4
                    },
                    "20": {
                        "style": 4
                    },
                    "21": {
                        "style": 4
                    },
                    "22": {
                        "style": 4
                    },
                    "23": {
                        "style": 4
                    },
                    "24": {
                        "style": 4
                    },
                    "25": {
                        "style": 4
                    },
                    "26": {
                        "style": 4
                    },
                    "27": {
                        "style": 4
                    },
                    "28": {
                        "style": 4
                    },
                    "29": {
                        "style": 4
                    },
                    "30": {
                        "style": 4
                    },
                    "31": {
                        "style": 4
                    },
                    "32": {
                        "style": 4
                    },
                    "33": {
                        "style": 4
                    },
                    "34": {
                        "style": 4
                    },
                    "35": {
                        "style": 4
                    },
                    "36": {
                        "style": 4
                    },
                    "37": {
                        "style": 4
                    },
                    "38": {
                        "style": 0
                    },
                    "39": {
                        "text": "",
                        "style": 3
                    },
                    "40": {
                        "text": ""
                    },
                    "41": {
                        "text": ""
                    },
                    "42": {
                        "text": ""
                    },
                    "43": {
                        "text": ""
                    },
                    "44": {
                        "text": ""
                    },
                    "45": {
                        "text": ""
                    },
                    "46": {
                        "text": ""
                    },
                    "47": {
                        "text": ""
                    },
                    "48": {
                        "text": ""
                    },
                    "49": {
                        "text": ""
                    },
                    "50": {
                        "text": ""
                    },
                    "51": {
                        "text": ""
                    }
                },
                "height": 36
            },
            "len": 100
        },
        "cols": {
            "26": {
                "width": 109
            },
            "39": {
                "width": 210
            },
            "len": 40
        },
        "validations": [],
        "autofilter": {}
    }
]